import { Component, HostListener, OnInit } from '@angular/core';
import { Category } from '../../../models/Category';
import { FileObject } from '../../../models/FileObject';
import { InfoCenterFile } from '../../../models/InfoCenterFile';
import { User } from '../../../models/User';
import { GlobalService } from '../../../services/global';
import { HttpService } from '../../../services/HttpService';

@Component({
  selector: 'app-addfile',
  templateUrl: './addfile.component.html',
  styleUrls: ['./addfile.component.css']
})
export class AddfileComponent implements OnInit {
  @HostListener('CategorySelectedEvent', ['$event'])
  onCatSelectedEvent(event: any) {
    this.SetCategoryParent(event.detail);
  }
  fileName: string = "";
  NewFile: FileObject;
  CurUser: User;
  CurrentFile: FormData;
  Categories: Category[];
  IsNew: boolean;
  constructor(private http:HttpService, private global:GlobalService) { }

  ngOnInit(): void {   
    //this.NewFile = new InfoCenterFile();
    this.http.GetCategories("infocenter").then(x => {
      this.Categories = x.Content;
    });
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
    });
  }

  onFileSelected(event) {
    let file = <File>event.target.files[0];
    debugger;

    if (file) {
      this.NewFile.FileName = file.name;      
      this.CurrentFile = new FormData();
      this.CurrentFile.append('file',file, file.name);
      this.NewFile.FileData = file;
    }
  }

  UploadFile() {

  }

  CreateNewFile(fileObj:any) {
    this.IsNew = true;
    this.NewFile = fileObj;
  }

  SetEditFile(fileObj: any) {
    this.IsNew = false;
    this.NewFile = fileObj;
  }

  GetFile():FileObject {
    return this.NewFile;
  }

  SetCategoryParent(cat: number) {
    this.NewFile.Category = cat;
  }
}
